import React, { useEffect, useState } from "react";
import { Modal, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchProjectHistoryById } from "../../../../../store/features/project/projectSlice";
import { format } from "date-fns";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FaFolderOpen } from "react-icons/fa6";
import ReactPaginate from "react-paginate";

const ProjectHistory = ({
  selectedProject,
  showProjectHistory,
  setShowProjectHistory,
}) => {
  const dispatch = useDispatch();

  const { assistantSuperAdmin } = useSelector((state) => state.users);
  const { role } = useSelector((state) => state.auth);
  const { workPackages } = useSelector((state) => state.workPackages);
  const { tasks } = useSelector((state) => state.tasks);
  const { projectHistory, loading, projectHistoryPagination } = useSelector(
    (state) => state.projects
  );

  const [currentPage, setCurrentPage] = useState(0);
  const limit = 10;
  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  useEffect(() => {
    if (selectedProject._id) {
      dispatch(
        fetchProjectHistoryById({
          projectId: selectedProject._id,
          page: currentPage + 1,
          limit,
        })
      );
    }
  }, [dispatch, selectedProject._id, currentPage]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
  const toggleDescription = (id) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <Modal
      size="lg"
      show={showProjectHistory}
      onHide={() => setShowProjectHistory(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{selectedProject.projectName} (History)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <Spinner animation="border" />
        ) : (
          <>
            <div className="table-wrapper">
              <Table responsive>
                <thead>
                  <tr>
                    <th>Project Name</th>
                    <th>Description</th>
                    <th>Assistant superadmin</th>
                    <th>Cost</th>
                    <th>Budget</th>
                    <th>Start date</th>
                    <th>End date</th>
                    <th>Document</th>
                  </tr>
                </thead>
                <tbody>
                  {projectHistory.length > 0 ? (
                    projectHistory.map(({ history }) => (
                      <tr key={history._id}>
                        <td>
                          {history.projectName}
                          <br />
                          <p
                            style={{
                              fontSize: 12,
                              color: "#666",
                              fontWeight: 600,
                            }}
                          >
                            <small>
                              {role === "superadmin"
                                ? history.workpackageCount || 0
                                : workPackages.length}{" "}
                              WPs,
                            </small>{" "}
                            <small>
                              {role === "superadmin"
                                ? history.taskCount || 0
                                : tasks.length}{" "}
                              Tasks
                            </small>
                          </p>
                        </td>
                        <td>
                          {history.description?.length > 50 ? (
                            <>
                              {expandedDescriptions[history._id]
                                ? history.description
                                : `${history.description.slice(0, 50)}... `}
                              <span
                                onClick={() => toggleDescription(history._id)}
                                style={{ color: "blue", cursor: "pointer" }}
                              >
                                {expandedDescriptions[history._id]
                                  ? "Show less"
                                  : "Show more"}
                              </span>
                            </>
                          ) : (
                            history.description
                          )}
                        </td>
                        <td>
                          {
                            assistantSuperAdmin?.find(
                              (pm) => pm._id === history.assistantSuperAdminId
                            )?.name
                          }
                        </td>
                        <td>{history.cost}</td>
                        <td>{history.budget}</td>
                        <td>{format(history.startDate, "MM/dd/yyyy")}</td>
                        <td>{format(history.endDate, "MM/dd/yyyy")}</td>
                        <td>
                          {history.document && (
                            <a
                              rel="noreferrer"
                              href={history.document}
                              download
                              target="_blank"
                            >
                              <IoDocumentTextOutline size={"1.2rem"} />
                            </a>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className="text-center py-5">
                        <div className="text-muted">
                          <FaFolderOpen size={50} className="mb-3" />
                          <h5>No project history found</h5>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {projectHistoryPagination?.totalPages > 1 && (
                <ReactPaginate
                  breakLabel="..."
                  nextLabel="Next >"
                  previousLabel="< Prev"
                  onPageChange={handlePageClick}
                  pageCount={projectHistoryPagination.totalPages}
                  forcePage={currentPage}
                  containerClassName="pagination"
                  activeClassName="active"
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={1}
                />
              )}
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ProjectHistory;
